import { post } from '@utils/request';
import securityCheck from './securityCheck';

/* global ACTION_ROUTES */

export default function deleteApplication(action) {
  if (!securityCheck('Bewerbung wirklich löschen?')) {
    return;
  }

  const applicationId = action.getAttribute('data-id');

  if (!isNaN(applicationId)) {
    post({
      url: ACTION_ROUTES.DELETE_APPLICATION,
      data: {
        applicationId: applicationId,
      },
      success: data => window.location.reload(),
    });
  }
}
